module.exports = __webpack_public_path__ + "img/bar_graph.ba56e32d.png";